var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeciality15(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#57719a;}.b{clip-path:url(#a);}.c,.d{fill:none;stroke:#208ce1;stroke-linecap:round;stroke-width:1.5px;}.c{stroke-linejoin:round;}.e{fill:#e2e8f3;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 50,
    height: 50,
    transform: "translate(-883 -8019)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(883 8019)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-31.683 -3.502)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-821.731-7983.37s-9.327,4.209-11.008.2,1.381-6.191,1.65-7.879c.251-1.575.885-4.571-3.864-6.413s-8.035,3.994-8.035,3.994",
    transform: "translate(0.383 1.294)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-841.026-7995.818s-4.785-2.465-5.959,3.051,5.465,7.662,5.465,7.662",
    transform: "translate(0 1.429)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-839.657-7990.868s-7.911,13.1,3.461,19.86,26.371-7.5,26.453-13.268c.044-3.069-.971-4.67-1.2-5.934-.126-.475.4-.639,2.1-2.605,3.626-4.2,4.984-13.391-2.828-17.653-6.82-3.722-17.993,2.388-14.483,14.773,1.534,6.136,5.169,5.485,5.169,5.485",
    transform: "translate(0.444 0.022)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-831.01-7988.721a2.986,2.986,0,0,0,2.682-.39c1.512-.926,3.316-3.071,6.047-2.926",
    transform: "translate(1.493 1.83)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-830.889-7992.844c-.244-2.438-1.65-6.228-7.628-8.763s-3.157-10.183-3.157-10.183",
    transform: "translate(2.208)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-827.1-7995.967l-2.974,1.608",
    transform: "translate(1.58 1.465)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M-844.969-8011.123s5.675,1.466,5.1,6.943c-.176,1.764-1.5,4.4-4.206,7.283-.041-1.7,2.523-3.882,2.376-7.681S-844.969-8011.123-844.969-8011.123Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeciality15);
export default __webpack_public_path__ + "static/media/speciality15.92b0b5b607b688ef1023b72249062c70.svg";
export { ForwardRef as ReactComponent };